import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import authService from "../services/authService";

const useAuthToken = () => {
    const { logout: contextLogout } = useContext(AuthContext);

    // Function to handle API calls with auto-refresh token logic
    const fetchWithAuth = async (url, options = {}) => {
        try {
            // Get auth headers from centralized service
            const authHeaders = await authService.getAuthHeaders();
            
            const response = await fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    ...authHeaders,
                },
            });

            // Handle 401 (Unauthorized) - token expired
            if (response.status === 401) {
                try {
                    // Try to refresh token
                    const newAuthHeaders = await authService.getAuthHeaders();
                    
                    // Retry the request with new token
                    return fetch(url, {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...newAuthHeaders,
                        },
                    });
                } catch (refreshError) {
                    contextLogout();
                    throw new Error("Session expired. Please log in again.");
                }
            }

            return response;
        } catch (error) {
            if (error.message === 'Authentication required') {
                contextLogout();
            }
            throw error;
        }
    };

    return { fetchWithAuth, logout: contextLogout };
};

export default useAuthToken;
